/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Contracts_Valid_UntilInputs */

const cs_contracts_valid_until = /** @type {(inputs: Contracts_Valid_UntilInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Platnost do`)
};

const en_contracts_valid_until = /** @type {(inputs: Contracts_Valid_UntilInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Valid until`)
};

/**
* | output |
* | --- |
* | "Valid until" |
*
* @param {Contracts_Valid_UntilInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const contracts_valid_until = /** @type {((inputs?: Contracts_Valid_UntilInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Contracts_Valid_UntilInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_contracts_valid_until(inputs)
	return cs_contracts_valid_until(inputs)
});